import React, { createRef } from "react";

import "./TextArea.scss";

export type TextAreaProps = {
  cx?: string;
  hasCount?: boolean;
  count: React.ComponentState;
  max?: number;
};

/**
 *
 * @param cx
 * @param hasCount useState
 * @param count
 * @param max
 * @constructor
 */
export const TextArea: React.FC<TextAreaProps> = ({
  cx = "",
  hasCount = false,
  count,
  max,
}) => {
  const ref = createRef<HTMLDivElement>();
  return (
    <div className={`TextArea ${cx}`} ref={ref}>
      <textarea
        maxLength={max}
        onChange={(e) => {
          if (!ref.current) return;

          const { scrollHeight, value } = e.target;

          if (ref.current.scrollHeight < scrollHeight) {
            ref.current.style.height = `${scrollHeight}px`;
          }
          count[1](value);
        }}
      />
      {hasCount && (
        <div className={"counter"}>
          {count[0].length ?? 0}
          {max && " / "}
          {max} 자
        </div>
      )}
    </div>
  );
};
